import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import WidgetContainer from './components/Widget/WidgetContainer';
import ErrorBoundary from './components/ErrorBoundary';

// Pages
import HomePage from './Pages/Home/HomePage';
import FashMatchPage from './Pages/FashMatch/FashMatchPage';
import FashSnapPage from './Pages/FashSnap/FashSnapPage';
import { FashPlayPage } from './Pages/FashPlay/FashPlayPage';
import FashFastPage from './Pages/FashFast/FashFastPage';
import RateLimitPage from './Pages/RateLimit/RateLimitPage';
import ErrorPage from './Pages/Error/ErrorPage';

// Legal Pages
import KVKKPage from './Pages/Legal/KVKKPage';
import ConsentPage from './Pages/Legal/ConsentPage';
import TermsPage from './Pages/Legal/TermsPage';

import './App.css';

const FashSizePage = React.lazy(() => import('./Pages/FashSize/FashSizePage'));

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <Router>
        <AppProvider>
          <div className="App">
            <WidgetContainer title="FashCortex">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/home" element={<HomePage />} />
                <Route path="/fash-match" element={<FashMatchPage />} />
                <Route path="/fash-snap" element={<FashSnapPage />} />
                <Route path="/fash-play" element={<FashPlayPage />} />
                <Route path="/fash-fast" element={<FashFastPage />} />
                <Route
                  path="/fash-size"
                  element={<React.Suspense fallback={<div className="app-loading">Fashsize hazırlanıyor…</div>}><FashSizePage /></React.Suspense>}
                />
                <Route path="/rate-limit" element={<RateLimitPage />} />
                <Route path="/error" element={<ErrorPage errorCode={500} />} />

                {/* Legal Routes */}
                <Route path="/kvkk-aydinlatma-metni" element={<KVKKPage />} />
                <Route path="/acik-riza-metni" element={<ConsentPage />} />
                <Route path="/kullanim-kosullari" element={<TermsPage />} />

                {/* 404 Catch-all route */}
                <Route path="*" element={<ErrorPage errorCode={404} />} />
              </Routes>
            </WidgetContainer>
          </div>
        </AppProvider>
      </Router>
    </ErrorBoundary>
  );
};

export default App;